export const BounceAddressDetails = {
  street_line_1: "333 Metro Park",
  street_line_2: "S-205",
  city: "Rochester",
  state: "New York",
  zipcode: "14623",
  phone_numbers: ["+18884825060"],
  fax_numbers: ["818.503.1961"],
};

export const DEFAULT_ADDRESS = `${BounceAddressDetails.street_line_1}, ${BounceAddressDetails.street_line_2}, ${BounceAddressDetails.city}, ${BounceAddressDetails.state} ${BounceAddressDetails.zipcode}`;

export const BounceLabel = "Bounce AI, Inc.";
